"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Either = void 0;
class Either {
}
exports.Either = Either;
Either.left = (value) => ({ direction: 'left', value });
Either.right = (value) => ({ direction: 'right', value });
Either.isLeft = (v) => v.direction === 'left';
Either.isRight = (v) => v.direction === 'right';
Either.leftMap = (f) => (eith) => (Either.isLeft(eith) ? Either.left(f(eith.value)) : eith);
Either.map = (f) => (eith) => (Either.isRight(eith) ? Either.right(f(eith.value)) : eith);
Either.flatMap = (f) => (eith) => (Either.isRight(eith) ? f(eith.value) : eith);
Either.cata = (lf) => (rf) => (eith) => (Either.isRight(eith) ? rf(eith.value) : lf(eith.value));
Either.filter = (predicate) => (filterError) => Either.cata(Either.left)(right => predicate(right) ? Either.right(right) : Either.left(filterError));
Either.filterType = (predicate) => (filterError) => Either.cata(Either.left)(right => predicate(right) ? Either.right(right) : Either.left(filterError));
Either.isValidEither = (obj) => typeof obj === 'object' &&
    obj !== null &&
    'direction' in obj &&
    typeof obj.direction === 'string' &&
    (obj.direction === 'Left' ||
        obj.direction === 'Right') &&
    'value' in obj &&
    obj.direction !== undefined;
//# sourceMappingURL=Either.js.map